<template>
  <div class="login-wrapper">
    <div class="login-header clearfix">
      <a
        :href="siteConfig.logoLink == '' ? '/' : siteConfig.logoLink"
        v-show="siteConfig.logo"
        class="fl logo"
      >
        <img :src="concatImageUrl(siteConfig.logo)" alt="logo" />
      </a>
      <div class="fr">
        <router-link :to="{ path: '/' }" class="logo" title="网站首页"
          >网站首页</router-link
        >
      </div>
    </div>

    <div class="login-live">
      <h3 class="login-live-title">观看登录</h3>
      <p class="login-live-text">信息输入</p>
      <div class="login-live-tips color1">
        <template v-if="errorTip">
          <Icon type="md-alert" />
          <span>{{ errorTip }}</span>
        </template>
      </div>
      <div class="login-live-form">
        <Form :model="loginData">
          <FormItem>
            <Input
              size="large"
              v-model="loginData.cellphone"
              placeholder="请输入您的手机号"
            />
          </FormItem>
          <FormItem v-if="loginType == 1">
            <i-input
              size="large"
              v-model="loginData.phoneCode"
              placeholder="请输入验证码"
            >
              <span class="phone-code" slot="append" @click="getPhoneCode">{{
                phoneCodeText
              }}</span>
            </i-input>
          </FormItem>
          <FormItem v-if="loginType == 2">
            <Input
              size="large"
              v-model="loginData.authorCode"
              placeholder="请输入您的邀请码"
            />
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              :loading="isLoading"
              size="large"
              long
              @click="liveLogin"
            >
              <span v-if="isLoading">登录中...</span>
              <span v-else>登录观看</span>
            </Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { account } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      liveId: 0,
      adminId: 0,
      loginType: 1,
      errorTip: "",
      loginData: {
        cellphone: "",
        phoneCode: "",
        authorCode: "",
      },
      phoneCodeText: "获取验证码",
      isLoading: false,
    };
  },
  mounted() {
    this.setMetaData("直播登录");
    if (!this.initParams()) {
      this.$Message.error("参数错误");
      return;
    }
    this.getLiveType();
  },
  methods: {
    initParams() {
      this.rdtUrl = this.$route.query.redirect;
      if (!this.rdtUrl) return false;
      let urlArray = this.rdtUrl.split("?");
      if (urlArray.length > 1) {
        const paramArray = urlArray[1].split("&");
        paramArray.forEach((item) => {
          let adminArray = item.split("=");
          if (
            adminArray.length > 1 &&
            adminArray[0].toLowerCase() == "adminid"
          ) {
            this.adminId = Number(adminArray[1]);
            return;
          }
        });
      }
      const tempIdIndex = urlArray[0].lastIndexOf("/");
      this.liveId = Number(urlArray[0].substring(tempIdIndex + 1));
      if (!this.liveId) return false;
      return true;
    },
    getLiveType() {
      account.getLiveLoginType(this.liveId).then((res) => {
        if (res.status === 1) {
          this.loginType = res.data;
        }
      });
    },
    liveLogin() {
      if (!this.loginData.cellphone) {
        this.errorTip = "请输入您的手机号";
        return;
      }
      if (this.loginType == 1 && !this.loginData.phoneCode) {
        this.errorTip = "请输入验证码";
        return;
      }
      if (this.loginType == 2 && !this.loginData.authorCode) {
        this.errorTip = "请输入您的邀请码";
        return;
      }
      this.errorTip = "";
      let data = {
        liveId: this.liveId,
        mobile: this.loginData.cellphone,
        verifyCode: this.loginData.phoneCode,
        inviteCode: this.loginData.authorCode,
        adminId: this.adminId,
        agencyId: this.siteConfig.agencyId,
      };
      account.checkLiveLogin(data).then((res) => {
        console.log(res);
        if (res.status === 1) {
          this.login(res.data);
          location.href = this.rdtUrl;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.loginData.cellphone) {
          this.errorTip = "请输入您的手机号";
          return;
        }
        this.isRequest = true;
        account.getPhoneCode(this.loginData.cellphone).then((result) => {
          if (result.status == 1) {
            let second = 60;
            let timer = setInterval(() => {
              second--;
              this.phoneCodeText = `还剩 ${second} 秒`;
              //console.log(second);
              if (second === 0) {
                this.phoneCodeText = "重新获取";
                this.isRequest = false;
                clearInterval(timer);
              }
            }, 1000);
            this.errorTip = "";
          } else {
            this.errorTip = result.message;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.showText {
  position: absolute;
  font-weight: bold;
  left: 100px;
  top: 100px;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  color: #f00;
  display: none;
}
.login-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/landing.png") center top;
  .login-header {
    width: 1000px;
    padding: 1rem 0;
    margin: 0 auto;
    & > div {
      margin-top: 1.6rem;
      text-align: right;
    }
    a {
      font-size: 1.6rem;
      color: #fff;
    }
    .logo {
      display: block;
      width: 250px;
      height: 50px;
      overflow: hidden;
      img {
        max-width: 250px;
        max-height: 50px;
      }
    }
  }
  .login-live {
    position: absolute;
    width: 1000px;
    height: 460px;
    left: 50%;
    top: 50%;
    margin-left: -500px;
    margin-top: -230px;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    .login-live-title {
      color: #333;
      font-size: 1.8rem;
      font-weight: normal;
      border-bottom: 1px solid #eee;
      padding: 1.6rem 0;
      text-align: center;
    }
    .login-live-text {
      text-align: center;
      margin: 2.4rem 0;
      font-size: 1.6rem;
    }
    .login-live-tips {
      line-height: 1;
      padding: 10px 0;
      width: 360px;
      margin: 0 auto;
      i {
        font-size: 1.8rem;
      }
      span {
        margin-left: 0.3rem;
      }
    }
    .login-live-form {
      width: 360px;
      margin: 10px auto;
      .phone-code {
        display: inline-block;
        width: 100px;
        cursor: pointer;
      }
    }
  }
  .login-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 1rem 0;
    border-top: 1px solid #ccc;
    text-align: center;
    color: #ccc;
  }
}
</style>